import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_GENERAL_SETTINGS_CLICK_DOMAINS = Symbol('general-settings.click-domains');

export const ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_ROUTE_NAME = Symbol('admin.settings.click-domains');
export const ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_LIST_ROUTE_NAME = Symbol('admin.settings.click-domains.list');
export const ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_ADD_ROUTE_NAME = Symbol('admin.settings.click-domains.add');

export const SETTINGS_CLICK_DOMAINS_LIST_URL = 'admin/click_domains/list';
export const SETTINGS_CLICK_DOMAINS_ADD_URL = 'admin/click_domains';
export const SETTINGS_CLICK_DOMAINS_SET_DEFAULT_URL = 'admin/click_domains/:id/set_default';

export const SETTINGS_CLICK_DOMAINS_LIST_QUERY_KEY = 'general-settings.click-domains';
export const SETTINGS_CLICK_DOMAINS_ADD_MUTATION_KEY = 'general-settings.click-domains.add';
export const SETTINGS_CLICK_DOMAINS_SET_DEFAULT_MUTATION_KEY = 'general-settings.click-domains.set-default';

export const ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_PERMISSIONS = {
  CLICKDOMAINS_SHOW: new Permission(
    PermissionsList.admin.CLICKDOMAINS_SHOW,
  ),
  CLICKDOMAINS_EDIT: new Permission(
    PermissionsList.admin.CLICKDOMAINS_EDIT,
  ),
};
